export const socialLinks = {
  twitter: 'https://twitter.com/basefactorteam',
  youtube: 'https://www.youtube.com/channel/UCuWGpvxPGh9UwYT21novrEg',
  github: 'https://github.com/orgs/Lemoncode',
  linkedin: 'https://www.linkedin.com/company/basefactor/about/',
}
